const isMenaHost = () => {
  if (typeof window === 'undefined') return false
  return window.location.hostname.toLowerCase().includes('mena')
}

export const Environment = {
  get apiUrl() {
    if (isMenaHost() && process.env.REACT_APP_API_URL_MENA) {
      return process.env.REACT_APP_API_URL_MENA
    }

    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL
    }

    throw new Error('There is not API URL configured')
  },


  get apiSdkUrl() {
    if (isMenaHost() && process.env.REACT_APP_API_SDK_URL_MENA) {
      return process.env.REACT_APP_API_SDK_URL_MENA
    }

    if (process.env.REACT_APP_API_SDK_URL) {
      return process.env.REACT_APP_API_SDK_URL
    }

    throw new Error('There is not API SDK URL configured')
  }
}
